import type { SettingsState } from './types';

const initialState: SettingsState = {
  emailNotifications: {
    matches: false,
    messages: false,
    promotions: false,
  },
  messageControls: {
    onlyVerifiedUsers: false,
    onlyVerifiedUsersError: false,
  },
  pushNotifications: {
    match: true,
    message: true,
    messageLike: true,
    superLike: true,
  },
};

export default initialState;
